import classNames from 'classnames';

import styles from '@containers/ResetPassword/ResetPassword.module.css';

import { Footer } from '@components/Footer/Footer';
import { ResetPasswordForm } from '@components/Forms/ResetPasswordForm/ResetPasswordForm';
import LogoDark from '@components/Logo/Logo';

export const ResetPassword = () => (
  <>
    <div className={classNames(styles.centeredPage)}>
      <div className={styles.formResetEmail}>
        <div className="text-center">
          <LogoDark
            href="/"
            className={classNames(styles.loginLogo, styles.aboveFormLogo)}
          />
        </div>
        <span className={classNames(styles.resetTitle, 'text-start')}>
          Password Recovery
        </span>
        <hr />
        <ResetPasswordForm />
      </div>
    </div>

    <Footer />
  </>
);
